/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { prettyNumber, targetCalculation } from '@global/helpers';

function BusinessLineChart({
  data = [],
  target = 0,
  barHeight = 12,
  styleCategory = {},
  hideCategory = false,
  categories = [],
}) {
  const [show, setShow] = useState(-1);

  const onEvent = (index, isShow = false) => {
    setShow(isShow ? index : -1);
  };

  const targetValue = (item) => {
    const target_value = targetCalculation(
      item.actual_value,
      item.target_value,
    );
    if (target_value > 100) {
      return 100;
    }
    return target_value;
  };

  return data.length ? (
    <View style={styles.container}>
      {data.map((item, idx) => (
        <View style={styles.progressWrapper} key={idx}>
          <SociollaText style={styles.textLeft} numberOfLines={1}>
            {item?.brand?.name}
          </SociollaText>
          <View style={[styles.progressParent, { height: barHeight }]}>
            <View
              style={[
                styles.progressChild,
                {
                  width: `${targetCalculation(item.target_value, target)}%`,
                  backgroundColor: Colors.yellow0,
                },
              ]}>
              <View
                style={[
                  styles.progressChild,
                  {
                    width: `${targetValue(item)}%`,
                    backgroundColor: Colors.blue0,
                  },
                ]}
                {...(isWeb
                  ? {
                      onMouseEnter: () => onEvent(idx, true),
                      onMouseLeave: () => onEvent(idx, false),
                    }
                  : {
                      onStartShouldSetResponder: () => true,
                      onResponderStart: () => onEvent(idx, true),
                    })}>
                {/* Custom Popup Start */}
                {show == idx ? (
                  <View style={[styles.textProgress, styles.textPopupText]}>
                    <SociollaText
                      type="medium"
                      style={styles.textPopupTextNumber}
                      numberOfLines={1}>
                      {item.actual_value}
                    </SociollaText>
                  </View>
                ) : (
                  false
                )}
                {/* Custom Popup End */}
                <SociollaText
                  type="medium"
                  style={[
                    styles.textProgress,
                    Math.ceil(
                      targetCalculation(item.actual_value, item.target_value),
                    ) < 100
                      ? styles.textProgressWarning
                      : {},
                  ]}>
                  {Math.ceil(
                    targetCalculation(item.actual_value, item.target_value),
                  )}
                  %
                </SociollaText>
              </View>
            </View>
          </View>
          <SociollaText type="medium" style={styles.textRight}>
            {prettyNumber(item.target_value)}
          </SociollaText>
        </View>
      ))}
      {!hideCategory ? (
        <View style={[styles.labelCat, styleCategory]}>
          {categories?.length ? (
            <>
              {categories.map((item, idx) => (
                <View style={styles.labelCatChild} key={idx}>
                  <View
                    style={[
                      styles.labelCatBox,
                      { backgroundColor: item.color },
                    ]}
                  />
                  <SociollaText type="medium" style={styles.labelCatText}>
                    {item.label}
                  </SociollaText>
                </View>
              ))}
            </>
          ) : (
            false
          )}
        </View>
      ) : (
        false
      )}
    </View>
  ) : (
    false
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingTop: 30,
  },
  labelCat: {
    position: 'absolute',
    right: 0,
    left: 0,
    bottom: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    ...(!isWeb
      ? {
          position: 'relative',
          marginTop: 10,
        }
      : {}),
  },
  labelCatChild: { marginHorizontal: 10, flexDirection: 'row' },
  labelCatBox: { width: 12, height: 12, marginRight: 10 },
  labelCatText: { fontSize: 10 },
  progressWrapper: {
    width: '100%',
    marginBottom: 25,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  textProgress: {
    position: 'absolute',
    top: -15,
    right: -10,
    color: Colors.green1,
    fontSize: 11,
  },
  textPopupText: {
    backgroundColor: Colors.grey0,
    paddingHorizontal: 7,
    paddingVertical: 3,
    borderRadius: 3,
    top: -25,
    left: 0,
    right: -25,
    zIndex: 100,
  },
  textPopupTextNumber: {
    fontSize: isWeb ? 13 : 10,
  },
  textProgressWarning: {
    color: Colors.red0,
  },
  textLeft: {
    width: '15%',
    textAlign: 'right',
    paddingRight: 10,
    color: Colors.grey1,
  },
  textRight: {
    width: isWeb ? '10%' : '15%',
    textAlign: 'right',
    paddingLeft: 10,
  },
  progressParent: { position: 'relative', width: isWeb ? '75%' : '70%' },
  progressChild: { position: 'absolute', top: 0, left: 0, bottom: 0 },
});

export default React.memo(BusinessLineChart, (prev, next) => prev == next);
